import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class SalesOrderAPI {

  static getList = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    fetch(Config.app.link + 'api/sales-order/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure)).catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure) => {
    const filter = [{field: 'model', type: 'model', 'condition': 'equals',
      value: `${modelType}~${modelId}`}];
    const page = 1;
    const perPage = 10;
    fetch(Config.app.link + 'api/sales-order/list', new Header('POST',
    { filter, page, perPage })).then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (sale, success, failure) => {
    fetch(Config.app.link + 'api/sales-order/add-edit', new Header('POST', sale))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/sales-order/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(`${Config.app.link}api/sales-order/delete/${id}`,
      new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static listProbability = (success, failure) => {
    fetch(Config.app.link + 'api/sales-order/probability', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveProbability = (product, success, failure) => {
    fetch(Config.app.link + 'api/sales-order/probability', new Header('POST', product))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteProbability = (id, success, failure) => {
    fetch(Config.app.link + 'api/sales-order/probability/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getInstallmentList = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    fetch(Config.app.link + 'api/sales-order/installment/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getInstallmentInnerList = (id, success, failure) => {
    const body = { filter: [{field: 'sales_order_id', type: 'sales_order',
        "condition": "equals", value: id }],
      page: 1, perPage: 10 };
    fetch(Config.app.link + 'api/sales-order/installment/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveInstallment = (installment, success, failure) => {
    fetch(Config.app.link + 'api/sales-order/installment/add-edit',
      new Header('POST', installment))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteInstallment = (id, success, failure) => {
    fetch(`${Config.app.link}api/sales-order/installment/delete/${id}`,
      new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveInstallmentMode = (mode, success, failure) => {
    fetch(Config.app.link + 'api/sales-order/installment/mode/add-edit',
      new Header('POST', mode))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteInstallmentMode = (id, success, failure) => {
    fetch(`${Config.app.link}api/sales-order/installment/mode/delete/${id}`,
      new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getFixedSalesOrderReportList = (filter, success, failure) => {
    const body = { filters : filter};
    fetch(Config.app.link + 'api/booking-report/bookingReport', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static download = (id, success, failure) => {
    fetch(`${Config.app.link}api/sales-order/download/${id}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

}
export default SalesOrderAPI;